import { render } from "./Anamneses.vue?vue&type=template&id=fe9ce3d8"
import script from "./Anamneses.vue?vue&type=script&lang=js"
export * from "./Anamneses.vue?vue&type=script&lang=js"

import "./Anamneses.vue?vue&type=style&index=0&id=fe9ce3d8&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__